import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UrlShortenerCollectionService } from "../../services/url-shortener-collection.service";

export interface DialogData {
    id: number;
  }
  

@Component({
    selector: 'delete-confirmation',
    templateUrl: 'delete-confirmation.html',
    styleUrls: ['./delete-confirmation.scss']
  })
  export class DeleteDialog {

    isDisabled = true;
    delete:any;
    constructor(
      public dialogRef: MatDialogRef<DeleteDialog>,
      private readonly urlShortenerService: UrlShortenerCollectionService,
      private readonly snackBar: MatSnackBar,
      @Inject(MAT_DIALOG_DATA) public data: DialogData,
    ) {}
  
    onNoClick(): void {
      this.dialogRef.close();
    }

    changeUpperCase(textToUpper: string){
        var newWord = textToUpper.toUpperCase();

        if(newWord === 'DELETE'){
            this.isDisabled = false;
        }else{
            this.isDisabled = true;
        }
    }

    deleteShortUrl(){
        this.urlShortenerService.delete(this.data.id).subscribe((result:any) =>{
            if(result.status === "Success"){
                this.dialogRef.close();
                this.snackBar.open('Successfully deleted.', 'Close', {
                    duration: 2000,
                    horizontalPosition: 'center',
                    verticalPosition: 'top'
                  });
                  this.dialogRef.close({ data: 'success' });
            }else{
                this.snackBar.open('Failed to delete data.', 'Close', {
                    duration: 2000,
                    horizontalPosition: 'center',
                    verticalPosition: 'top'
                  });
            }
        })
    }
  }